import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
} from "antd";
import React from "react";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";
import PageHeading from "../../../../../components/common/PageHeading";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";
import RightBar from "../../../../../components/common/RightBar";


const subsidyReceipt = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod("New Bank Deposit", "1", "", "", "/accounting/receivables_payments/bank_deposits/NewBankDeposit"),
    ]),
    RightBarMethod("REPORTS", "t2", <i className="fa-solid fa-chart-column"></i>, [
      RightBarMethod("Receivables Activity", "2", "", "", ""),
      RightBarMethod("Aged Receivable Details", "3", "", "", ""),
    ]),
    RightBarMethod("HELP TOPICS", "t3", <i className="fa-solid fa-circle-question"></i>, [
      RightBarMethod("Subsidy Receipts", "4", "", "", ""),
    ]),
  ];

const SubsidyReceipt = () => {
  return (
    <div className="SubsidyReceipt">
      <PageHeading heading="Subsidy Receipts" />
      <Form autoComplete="off" layout="vertical">
        <Card>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Property" name="property" required>
                <Select
                  showSearch
                  placeholder="Select..."
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value: "test1",
                      label: "test1",
                    },
                    {
                      value: "test2",
                      label: "test2",
                    },
                    {
                      value: "test3",
                      label: "test4",
                    },
                  ]}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="GL Account"
                name="GLAccount"
                required
                autoComplete="off"
              >
                <Select
                  placeholder="Select..."
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value: "Section 8 Rent",
                      label: "Section 8 Rent",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Receipt Date" name="receiptDate" required>
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Remarks" name="remarks">
                <Input placeholder="e.g. November Rent" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Reference" name="reference">
                <Input placeholder="e.g. Check #123" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Cash Account" name="CashAccount">
                <Select
                  optionFilterProp="children"
                  defaultValue="Automatic"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value: "Automatic",
                      label: "Automatic",
                    },
                    {
                      value: "23291: Rental Income Account",
                      label: "23291: Rental Income Account",
                    },
                    {
                      value: "23292: Security Deposits Bank Account",
                      label: "23292: Security Deposits Bank Account",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Subsidy Received" name="subsidyReceived">
                <Input prefix={<i className="fa-solid fa-dollar-sign"></i>} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item label="Payment Type" name="paymentType">
                <Select
                  defaultValue="Subsidized"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value: "Check",
                      label: "Check",
                    },
                    {
                      value: "Money Order",
                      label: "Money Order",
                    },
                    {
                      value: "Cash",
                      label: "Cash",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <br />
        <Card>
          <p style={{ textAlign: "center" }}>
            Select property and GL Account to populate outstanding charges
          </p>
        </Card>
        <br />
        {/* <AttachmentsUpload /> */}

        <Row gutter={16}>
            <Col>
              <Button type="primary">Save</Button>
            </Col>
            <Col>
              <Button type="link">Cancel</Button>
            </Col>
          </Row>
      </Form>
      <div className="RightSidebar">
        <RightBar RightBarData={subsidyReceipt} />
      </div>
    </div>
  );
};

export default SubsidyReceipt;
